import React from "react";
import {getConfig} from "../../_metronic/i18n";
import PropTypes from "prop-types";
import {shallowEqual, useSelector} from "react-redux";
import {roles} from "../../index";


const config = getConfig();
/* Role checker */
export const AERole = ({accept = [roles.visitor], isEmailVerified = true, children}) =>{
  const {_isEmailVerified = false, authUser} = useSelector( ({auth}) => ({ _isEmailVerified: auth.user && auth.user.email_verified_at, authUser:auth.user }), shallowEqual );

  // if(accept)
  // if(isAuthorized) accept.push(roles.client, roles.provider, roles.super_admin)
  const roleExists = accept.filter((s,i,self)=>self.indexOf(s) === i).includes(config.role);
  let result = "";
  // console.log(authUser, _isEmailVerified, children)
  if(roleExists){
    if(isEmailVerified){
      if(_isEmailVerified) {
        result = children
      }


    }else {
      result = children
    }
  }

  return (
    <React.Fragment>
      {  result  }
    </React.Fragment>
  )
}

AERole.propTypes = {
  //todo fix accept : PropTypes.arrayOf(PropTypes.oneOf([roles.client, roles.provider, roles.visitor, roles.super_admin])),
  isAuthorized : PropTypes.bool
};